import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TEAM_PATCH_REQUEST = 'PATCH_TEAM_REQUEST';
export const TEAM_PATCH_FAILURE = 'PATCH_TEAM_FAILURE';
export const TEAM_PATCH_SUCCESS = 'PATCH_TEAM_SUCCESS';

export const patchTeam = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.TEAM.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => dispatch(patchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return {
        type: TEAM_PATCH_REQUEST,
    }
};

const postFailure = (error) => {
    return {
        type: TEAM_PATCH_FAILURE,
        error,
    }
};

const patchSuccess = (team) => {
    return {
        type: TEAM_PATCH_SUCCESS,
        team,
    }
};